import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import { api, brl } from "@/lib/api";
import { useAdminTheme } from "./AdminLayout";
import { FilterBar, useAdminFilters, cityParam } from "./filters";

export default function AdminFinance() {
  const { accent } = useAdminTheme();
  const f = useAdminFilters();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/finance", { params: { city_id: cityParam(f), period: f.period } })
      .then(({ data }) => setD(data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [f.cityId, f.period]);

  return (
    <div data-testid="admin-finance">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-extrabold">Financeiro</h1>
          <p className="text-sm text-gray-500">
            Divisão de cada real: 3,5% Prefeitura · 2,5% Time Food · 3,5% indicação nível 1 · 2,5% nível 2 · R$ 0,99 serviço
          </p>
        </div>
        <FilterBar f={f} accent={accent} />
      </div>

      {!d ? <p className="text-sm text-gray-500 mt-8">Carregando…</p> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mt-6">
            <Card testId="finance-total-lojista" label="Valor ao lojista" value={brl(d.totals.lojista)} color="#141414" />
            <Card testId="finance-total-motoboy" label="Repasse motoboy" value={brl(d.totals.motoboy)} color="#2E8B57" />
            <Card testId="finance-total-prefeitura" label="Prefeitura (3,5%)" value={brl(d.totals.prefeitura)} color="#1F3864" />
            <Card testId="finance-total-timefood" label="Time Food (2,5% + R$0,99)" value={brl(d.totals.timefood)} color="#FF7A1A" />
            <Card testId="finance-total-indicacao" label="Indicações (nível 1 + 2)" value={brl(d.totals.indicacao)} color="#E53238" />
          </div>

          <div className="rounded-2xl border border-gray-200 bg-white p-5 mt-5">
            <h2 className="font-display font-bold text-lg">Evolução do split por dia</h2>
            <p className="text-xs text-gray-500">
              {d.orders_count} pedidos · GMV {brl(d.totals.gmv)} · taxa de serviço acumulada {brl(d.totals.service_fee)}
            </p>
            <div className="mt-4" data-testid="admin-finance-chart">
              <ResponsiveContainer width="100%" height={330}>
                <BarChart data={d.series}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EEE" />
                  <XAxis dataKey="day" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} />
                  <Tooltip formatter={(v) => brl(v)} />
                  <Legend wrapperStyle={{ fontSize: 11 }} />
                  <Bar dataKey="lojista" name="Lojista" stackId="a" fill="#141414" />
                  <Bar dataKey="prefeitura" name="Prefeitura" stackId="a" fill="#1F3864" />
                  <Bar dataKey="timefood" name="Time Food" stackId="a" fill="#FF7A1A" />
                  <Bar dataKey="indicacao" name="Indicações" stackId="a" fill="#E53238" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const Card = ({ label, value, color, testId }) => (
  <div data-testid={testId} className="rounded-2xl border border-gray-200 bg-white p-4">
    <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ background: color }} />
    <p className="text-[11px] text-gray-500 mt-2">{label}</p>
    <p className="font-display text-lg font-extrabold">{value}</p>
  </div>
);
